export const COLLECTIONS = {
  // Core
  TENANTS: 'tenants',
  TENANT_PUBLIC_PROFILES: 'tenantPublicProfiles',
  USERS: 'users',
  ROLES: 'roles',
  BRANCHES: 'branches',
  BRANCH_TRANSFERS: 'branchTransfers',

  // HR
  EMPLOYEES: 'employees',
  ATTENDANCE: 'attendance',
  LEAVES: 'leaves',
  PAYROLL: 'payroll',
  UNLOADING_LABOUR: 'unloadingLabour',

  // Customers / Growers / Products
  CUSTOMERS: 'customers',
  GROWERS: 'growers',
  PRODUCTS: 'products',
  CATEGORIES: 'categories',
  PRODUCT_VARIETIES: 'productVarieties',
  AGREEMENTS: 'agreements',

  // Inventory / Warehouse
  INWARDS: 'inwards',
  LOTS: 'lots',
  CHAMBERS: 'chambers',
  BINS: 'bins',
  FINANCIAL_YEARS: 'financialYears',
  STOCK_MOVEMENTS: 'stockMovements',
  INVENTORY_TRANSFERS: 'inventoryTransfers',
  INVENTORY_ADJUSTMENTS: 'inventoryAdjustments',
  REJECTIONS: 'rejections',
  CRATES: 'crates',
  CRATE_GATE_PASSES: 'crateGatePasses',
  CRATE_STOCK: 'crates',
  CRATE_MOVEMENTS: 'stockMovements',
  CRATE_RECONCILIATIONS: 'crateReconciliations',
  PACKING_PACKAGES: 'packingPackages',
  WAREHOUSES: 'warehouses',

  // Outward / Dispatch
  OUTWARDS: 'outwards',
  OUTWARD: 'outwards',
  DISPATCHES: 'dispatches',
  DISPATCH: 'dispatches',

  // Trading / Billing
  PURCHASES: 'purchases',
  SALES: 'sales',
  INVOICES: 'invoices',
  PAYMENTS: 'payments',
  PLANS: 'plans',
  SUBSCRIPTIONS: 'subscriptions',
  NOTIFICATIONS: 'notifications',
  FORM_SETTINGS: 'formSettings',
  TENANT_MODULES: 'tenantModules',
  ADDON_REQUESTS: 'addonRequests',
  PLATFORM_PAYMENTS: 'platformPayments',
  PLATFORM_RECEIPTS: 'platformReceipts',
  PLATFORM_SUPPORT_TICKETS: 'platformSupportTickets',
  PLATFORM_SUPPORT_MESSAGES: 'platformSupportMessages',
  PLATFORM_CRM_LEADS: 'platformCrmLeads',
  PLATFORM_CRM_ACTIVITIES: 'platformCrmActivities',
  TENANT_INTEGRATIONS: 'tenantIntegrations',
  CRM_LEADS: 'crmLeads',
  CRM_ACTIVITIES: 'crmActivities',
  CRM_TASKS: 'crmTasks',
  CRM_TICKETS: 'crmTickets',
  CHEQUES: 'cheques',
  BANK_RECONCILIATIONS: 'bankReconciliations',

  // Legacy/core finance aliases still used by financialService CRUD.
  ACCOUNTS: 'accounts',
  LEDGER: 'ledger',
  TRANSACTIONS: 'transactions',

  // Dispatch workflow companion collections.
  LOADING: 'loading',
  DELIVERY: 'delivery',

  // Product storage history used by productService.
  STORAGE_RECORDS: 'storageRecords',

  LABEL_TEMPLATES: 'labelTemplates',
  EMPLOYEE_FINANCE: 'employeeFinanceRecords',
  EMPLOYEE_FINANCE_RECOVERIES: 'employeeFinanceRecoveries',

  // System
  COUNTERS: 'counters',
  AUDIT_LOGS: 'auditLogs',
  SYSTEM_SETTINGS: 'systemSettings',
  SETTINGS: 'settings',

  // Inward aliases
  INWARD: 'inwards',
  INWARD_AUDIT: 'auditLogs',
  DRIVERS: 'drivers',
  VEHICLES: 'vehicles',
  STORAGE_RESERVATIONS: 'storageReservations',

  // Canonical compatibility aliases used by feature services and reports.
  // Values intentionally match the existing service fallbacks so legacy data
  // continues to live in the same Firestore collections.
  COMPANIES: 'companies',
  INVENTORY: 'inventory',
  TRADES: 'trades',
  TRADING: 'trades',
  BOOKINGS: 'outwardBookings',
  OUTWARD_BOOKINGS: 'outwardBookings',
  GATE_PASSES: 'outwardGatePasses',
  OUTWARD_GATE_PASSES: 'outwardGatePasses',
  OUTWARD_RETURNS: 'outwardReturns',
  STORAGE_ALLOCATIONS: 'storageAllocations',
  STOCK_ITEMS: 'stockItems',
  STOCK_TRANSACTIONS: 'stockTransactions',
  STOCK_PURCHASES: 'stockPurchases',
  STOCK_ISSUES: 'stockIssues',
  STOCK_OWNERSHIP_TRANSFERS: 'stockOwnershipTransfers',
  SUPPLIER_LEDGER: 'supplierLedger',
  GROWER_LEDGER: 'growerLedger',
  LEDGER_PARTIES: 'ledgerParties',
  PARTIES: 'ledgerParties',
  CRATE_LEDGER: 'crateLedger',
  STORAGE_RECEIPTS: 'storageReceipts',
  STORAGE_INVOICES: 'storageInvoices',
  GRADING_RUNS: 'gradingRuns',
  GRADING_INVOICES: 'gradingInvoices',
  OUTWARD_INVOICES: 'outwardInvoices',
  FINANCE_EXPENSES: 'financeExpenses',
  EXPENSES: 'financeExpenses',
  FINANCE_EXPENSE_CATEGORIES: 'financeExpenseCategories',
  EXPENSE_CATEGORIES: 'financeExpenseCategories',
  FINANCE_ACCOUNTS: 'financeAccounts',
  FINANCE_TRANSACTIONS: 'financeTransactions',
  ACCOUNT_TRANSACTIONS: 'financeTransactions',
  FINANCE_INCOME: 'financeIncome',
  MANUAL_INCOME: 'financeIncome',
  FINANCE_INVOICES: 'invoices',
  MANUAL_INVOICES: 'invoices',
  RECEIPTS: 'receipts',
  TRADE_PAYMENTS: 'tradePayments',
  IOT_SENSORS: 'iotSensors',
  TEMPERATURE_SENSORS: 'iotSensors',
  SENSORS: 'iotSensors',
  TEMPERATURE_READINGS: 'temperatureReadings',
  READINGS: 'temperatureReadings',
  TEMPERATURE_ALERTS: 'temperatureAlerts',
  ALERTS: 'temperatureAlerts',
  TEMPERATURE_LOGS: 'temperatureReadings',
  SYSTEM_ERRORS: 'systemErrors',
  NOTIFICATION_SETTINGS: 'notificationSettings',
  NOTIFICATION_EVENTS: 'notificationEvents',
  NOTIFICATION_DELIVERIES: 'notificationDeliveries',
  NOTIFICATION_DEVICES: 'notificationDevices',
  ATTENDANCE_SETTINGS: 'attendanceSettings',
  ATTENDANCE_CONFIG: 'attendanceSettings',
  HR_ATTENDANCE_SETTINGS: 'attendanceSettings',
  LEAVE_REQUESTS: 'leaveRequests',
  PAYROLL_RECORDS: 'payroll',
  PAYROLLS: 'payroll',
  PRODUCT_VARIETY: 'productVarieties',
  VARIETIES: 'productVarieties',
  FORMSETTINGS: 'formSettings',
  WAREHOUSE: 'warehouses',
  CHAMBER: 'chambers'
};

export default COLLECTIONS;